// MIT License - Copyright (c) 2026 Doug McNall

import { starSystems, starPositions } from './StarSystemsConfig';
import { warpGates, warpGatePositions } from './WarpGatesConfig';
import { HaloAliensPlanets } from './AliensConfig';

export const universeHalo = {
  id: 'halo',
  starSystems,
  starPositions,
  warpGates,
  warpGatePositions,
  aliens: HaloAliensPlanets
};

export default universeHalo;
